import React from 'react';
import GenericSectionBody from './generic';
import PhoneSectionBody from './phone';

export function EnrichmentSectionBody({ sectionKey, detectedType, section }) {
  const data = section?.data ?? (section?.status ? {} : section);
  const wrappedSection = section?.status ? section : { status: 'success', data: section };

  if (detectedType === 'phone') {
    return (
      <PhoneSectionBody
        sectionKey={sectionKey}
        section={wrappedSection}
        data={data}
      />
    );
  }

  return <GenericSectionBody section={wrappedSection} data={data} />;
}
